<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container" v-if="p_idAtencion">
            <router-link to="/atencionfacturacion">Atenciones Médicas</router-link> &rsaquo;
            <router-link :to="`/atencion_atenciondet/${p_idAtencion}`">Atención {{ p_numero }}</router-link>
            &rsaquo; Factura {{ datoFactura.numero }}
          </div>
          <div class="breadcrumb-container" v-if="!p_idAtencion">
            <router-link to="/factura">Facturas</router-link>
            &rsaquo; Factura {{ datoFactura.numero }}
          </div>
        </div>
        <div class="col-1">
          <span class="material-symbols-outlined" style="font-size:32px;color:blue;cursor:pointer"
            @click="showModalHelp = true">help</span>
        </div>
      </div>
    </div>

    <div v-for="(n, i) in notificaciones" :key="i" class="notification-area">
      <div class="notification-message"
        :class="{ 'is-success': n.type === 'success', 'is-error': n.type === 'error' }">
        {{ n.message }}
      </div>
    </div>

    <Modal v-model:modelValue="showModalHelp">
      <AyudaFacturacion />
    </Modal>
    <hr>

    <!-- ── Master ─────────────────────────────────────────────── -->
    <div class="fact-card mb-4">

      <!-- Barra superior: estado + acciones -->
      <div class="fact-header">
        <div class="d-flex align-items-center gap-2">
          <span class="fact-numero">Factura {{ datoFactura.numero }}</span>
<span class="fact-badge" :class="badgeEstadoFactura(datoFactura.estadoFactura)">
  {{ datoFactura.estadoFactura }}
</span>
        </div>
        <div class="d-flex gap-2" v-if="datoFactura.estadoFactura === 'PENDIENTE'">
          <button class="btn btn-sm btn-outline-primary d-flex align-items-center gap-1"
            @click.prevent="guardarFactura('PENDIENTE')">
            <i class="material-icons" style="font-size:16px">update</i>
            Actualizar
          </button>
          <button class="btn btn-sm btn-success d-flex align-items-center gap-1"
            @click.prevent="guardarFactura('EMITIDA')">
            <span class="material-symbols-outlined" style="font-size:16px">order_play</span>
            Emitir
          </button>
        </div>
        <div class="d-flex gap-2" v-if="datoFactura.estadoFactura !== 'ANULADA'">
          <button
            class="btn btn-sm btn-outline-danger d-flex align-items-center gap-1"
            data-bs-toggle="modal"
            data-bs-target="#modalAnulacion"
          >
            <span class="material-symbols-outlined" style="font-size:16px">disabled_by_default</span>
            Anular
          </button>
        </div>		
      </div>

      <!-- Cuerpo del formulario -->
      <div class="fact-body">

        <!-- Fila 1: número, fecha, estado -->
        <div class="fact-row">
          <div class="fact-field fact-field--sm">
            <span class="fact-lbl">Número</span>
            <span class="fact-val">{{ datoFactura.numero }}</span>
          </div>
          <div class="fact-field fact-field--sm">
            <span class="fact-lbl">Fecha Emisión</span>
            <span class="fact-val">{{ getFormattedDate(datoFactura.fechaEmision) }}</span>
          </div>
          <div class="fact-field fact-field--sm">
            <span class="fact-lbl">Estado</span>
<span class="fact-val">
  <span class="fact-badge" :class="badgeEstadoFactura(datoFactura.estadoFactura)">
    {{ datoFactura.estadoFactura }}
  </span>
</span>
          </div>
        </div>

        <!-- Fila 2: persona con buscador -->
<!-- Fila 2: persona con buscador -->
<div class="fact-row">
  <div class="fact-field fact-field--full">
    <span class="fact-lbl">Persona</span>
    <div class="position-relative">
      <div class="persona-row">

        <!-- Ícono -->
        <span class="material-symbols-outlined persona-icon-side">person_search</span>

        <!-- Input -->
        <div class="persona-input-wrap">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="personaSearch"
            @input="onPersonaInput"
            @focus="mostrarDropdownPersona = true"
            @blur="ocultarDropdownPersona"
            :placeholder="personaSeleccionada || 'Buscar por nombre o cédula...'"
            :disabled="datoFactura.estadoFactura !== 'PENDIENTE'"
            autocomplete="off"
          />
          <!-- Dropdown -->
          <ul v-if="mostrarDropdownPersona && personasFiltradas.length"
            class="persona-dropdown shadow">
            <li v-for="p in personasFiltradas" :key="p.idPersona"
              class="persona-option"
              @mousedown.prevent="seleccionarPersona(p)">
              <span class="persona-doc">{{ p.documento }}</span>
              <span class="persona-nombre">{{ p.nombreCompleto }}</span>
            </li>
          </ul>
          <div v-if="mostrarDropdownPersona && personaSearch.length >= 2 && !buscandoPersona && !personasFiltradas.length"
            class="persona-dropdown shadow">
            <div class="persona-empty">
              <span class="material-symbols-outlined" style="font-size:16px">search_off</span>
              Sin resultados para "{{ personaSearch }}"
            </div>
          </div>
          <div v-if="mostrarDropdownPersona && personaSearch.length > 0 && personaSearch.length < 2"
            class="persona-dropdown shadow">
            <div class="persona-empty">Escribe al menos 2 caracteres...</div>
          </div>
        </div>

        <!-- Spinner -->
        <span v-if="buscandoPersona" class="persona-side-spinner">
          <span class="spinner-border spinner-border-sm text-secondary"></span>
        </span>

        <!-- Botón X -->
        <button
          v-if="(personaSearch || personaSeleccionada) && datoFactura.estadoFactura == 'PENDIENTE'"
          class="persona-clear-btn"
          @mousedown.prevent="limpiarPersona"
          title="Limpiar selección"
        >
          <span class="material-symbols-outlined" style="font-size:16px">close</span>
        </button>

      </div>
    </div>
  </div>
</div>

        <!-- Fila 3: descripción -->
        <div class="fact-row">
          <div class="fact-field fact-field--full">
            <span class="fact-lbl">Descripción</span>
            <textarea
              class="form-control form-control-sm"
              v-model="datoFactura.descripcion"
              :disabled="datoFactura.estadoFactura !== 'PENDIENTE'"
              style="text-transform:uppercase; resize:none"
              rows="2"
            />
          </div>
        </div>

        <!-- Más información -->
        <button class="btn-toggle mt-2" @click.prevent="mostrarBloque = !mostrarBloque">
          <span class="material-symbols-outlined" style="font-size:15px;vertical-align:-3px">
            {{ mostrarBloque ? 'expand_less' : 'expand_more' }}
          </span>
          {{ mostrarBloque ? 'Menos información' : 'Más información' }}
        </button>

<div v-if="mostrarBloque" class="fact-extra mt-3">

  <!-- Empresa -->
  <p class="fact-seccion-titulo">
    <span class="material-symbols-outlined" style="font-size:15px;vertical-align:-2px">business</span>
    Empresa
  </p>
  <div class="fact-row">
    <div class="fact-field">
      <span class="fact-lbl">Razón Social</span>
      <span class="fact-val muted">{{ datoFactura.empresaRazonSocial }}</span>
    </div>
    <div class="fact-field">
      <span class="fact-lbl">Nombre Corto</span>
      <span class="fact-val muted">{{ datoFactura.empresaNombreCorto }}</span>
    </div>
  </div>
  <div class="fact-row">
    <div class="fact-field">
      <span class="fact-lbl">Dirección</span>
      <span class="fact-val muted">{{ datoFactura.empresaDireccion }}</span>
    </div>
    <div class="fact-field fact-field--sm">
      <span class="fact-lbl">Teléfono</span>
      <span class="fact-val muted">{{ datoFactura.empresaTelefono }}</span>
    </div>
    <div class="fact-field fact-field--sm">
      <span class="fact-lbl">Ciudad</span>
      <span class="fact-val muted">{{ datoFactura.empresaCiudad }}</span>
    </div>
  </div>

  <hr class="fact-divider">

  <!-- Persona -->
  <p class="fact-seccion-titulo">
    <span class="material-symbols-outlined" style="font-size:15px;vertical-align:-2px">person</span>
    Receptor
  </p>
  <div class="fact-row">
    <div class="fact-field">
      <span class="fact-lbl">Nombre</span>
      <span class="fact-val muted">{{ datoFactura.personaNombre }}</span>
    </div>
    <div class="fact-field fact-field--sm">
      <span class="fact-lbl">Documento</span>
      <span class="fact-val muted">{{ datoFactura.personaDocumento }}</span>
    </div>
  </div>
  <div class="fact-row">
    <div class="fact-field">
      <span class="fact-lbl">Dirección</span>
      <span class="fact-val muted">{{ datoFactura.personaDireccion }}</span>
    </div>
    <div class="fact-field fact-field--sm">
      <span class="fact-lbl">Teléfono</span>
      <span class="fact-val muted">{{ datoFactura.personaTelefono }}</span>
    </div>
  </div>

  <hr class="fact-divider">

  <!-- Financiero -->
  <p class="fact-seccion-titulo">
    <span class="material-symbols-outlined" style="font-size:15px;vertical-align:-2px">calculate</span>
    Totales
  </p>
  <div class="fact-row">
    <div class="fact-field fact-field--sm">
      <span class="fact-lbl">Subtotal 0%</span>
      <span class="fact-val muted text-end">{{ formatMoneda(datoFactura.subtotal0) }}</span>
    </div>
    <div class="fact-field fact-field--sm">
      <span class="fact-lbl">Subtotal 12%</span>
      <span class="fact-val muted text-end">{{ formatMoneda(datoFactura.subtotal12) }}</span>
    </div>
    <div class="fact-field fact-field--sm">
      <span class="fact-lbl">Subtotal 15%</span>
      <span class="fact-val muted text-end">{{ formatMoneda(datoFactura.subtotal15) }}</span>
    </div>
    <div class="fact-field fact-field--sm">
      <span class="fact-lbl">Descuento</span>
      <span class="fact-val muted text-end">{{ formatMoneda(datoFactura.totalDescuento) }}</span>
    </div>
    <div class="fact-field fact-field--sm">
      <span class="fact-lbl">IVA</span>
      <span class="fact-val muted text-end">{{ formatMoneda(datoFactura.totalIva) }}</span>
    </div>
    <div class="fact-field fact-field--sm">
      <span class="fact-lbl fw-bold">Total a Pagar</span>
      <span class="fact-val text-end fw-bold">{{ formatMoneda(datoFactura.totalPagar) }}</span>
    </div>
  </div>

  <hr class="fact-divider">

  <!-- SRI -->
  <p class="fact-seccion-titulo">
    <span class="material-symbols-outlined" style="font-size:15px;vertical-align:-2px">verified</span>
    SRI / Electrónica
  </p>
  <div class="fact-row">
    <div class="fact-field fact-field--sm">
      <span class="fact-lbl">Ambiente</span>
      <span class="fact-val muted">{{ datoFactura.ambiente === '1' ? 'Pruebas' : datoFactura.ambiente === '2' ? 'Producción' : '—' }}</span>
    </div>
    <div class="fact-field fact-field--sm">
      <span class="fact-lbl">Tipo Emisión</span>
      <span class="fact-val muted">{{ datoFactura.tipoEmision === '1' ? 'Normal' : datoFactura.tipoEmision === '2' ? 'Indisponibilidad' : '—' }}</span>
    </div>
    <div class="fact-field fact-field--sm">
      <span class="fact-lbl">Fecha Autorización</span>
      <span class="fact-val muted">{{ getFormattedDate(datoFactura.fechaAutorizacion) }}</span>
    </div>
    <div class="fact-field fact-field--sm">
      <span class="fact-lbl">Fecha Emisión Electrónica</span>
      <span class="fact-val muted">{{ getFormattedDate(datoFactura.fechaEmisionElectronica) }}</span>
    </div>
  </div>
  <div class="fact-row">
    <div class="fact-field">
      <span class="fact-lbl">Número Autorización</span>
      <span class="fact-val muted" style="font-family:monospace;font-size:0.78rem;word-break:break-all">
        {{ datoFactura.numeroAutorizacion || '—' }}
      </span>
    </div>
  </div>
  <div class="fact-row">
    <div class="fact-field">
      <span class="fact-lbl">Clave de Acceso</span>
      <span class="fact-val muted" style="font-family:monospace;font-size:0.78rem;word-break:break-all">
        {{ datoFactura.claveAcceso || '—' }}
      </span>
    </div>
  </div>

  <hr class="fact-divider">

  <!-- Auditoría -->
  <p class="fact-seccion-titulo">
    <span class="material-symbols-outlined" style="font-size:15px;vertical-align:-2px">manage_accounts</span>
    Auditoría
  </p>
  <div class="fact-row">
    <div class="fact-field">
      <span class="fact-lbl">Usuario Registro</span>
      <span class="fact-val muted">{{ datoFactura.usrRegNombre || datoFactura.idUsuarioReg }}</span>
    </div>
    <div class="fact-field fact-field--sm">
      <span class="fact-lbl">Fecha Registro</span>
      <span class="fact-val muted">{{ getFormattedDate(datoFactura.fechaReg) }}</span>
    </div>
  </div>
  <div class="fact-row">
    <div class="fact-field">
      <span class="fact-lbl">Usuario Actualización</span>
      <span class="fact-val muted">{{ datoFactura.usrActNombre || datoFactura.idUsuarioAct }}</span>
    </div>
    <div class="fact-field fact-field--sm">
      <span class="fact-lbl">Fecha Actualización</span>
      <span class="fact-val muted">{{ getFormattedDate(datoFactura.fechaAct) }}</span>
    </div>
  </div>

</div>

      </div>
    </div>

    <!-- ── Tabs ───────────────────────────────────────────────── -->
<div class="tab-bar mt-3">
  <button class="tablink" :class="{ 'active-tab': showTable === 'facturaDet' }"
    @click="showTable = 'facturaDet'">
    <span class="material-symbols-outlined">list_alt</span>
    Detalle
  </button>
  <button class="tablink" :class="{ 'active-tab': showTable === 'facturaXML' }"
    @click="showTable = 'facturaXML'">
    <span class="material-symbols-outlined">code</span>
    XML
  </button>
  <button class="tablink" :class="{ 'active-tab': showTable === 'pago' }"
    @click="showTable = 'pago'">
    <span class="material-symbols-outlined">payments</span>
    Pagos
  </button>
</div>

    <div v-if="showTable === 'facturaDet'">
      <FacturaDet :p_idFactura="p_idFactura" :p_estadoFactura="datoFactura.estadoFactura" />
    </div>
    <div v-if="showTable === 'facturaXML'">
      <FacturaXML :p_idFactura="p_idFactura" />
    </div>
    <div v-if="showTable === 'pago'">
      <Pago :p_idFactura="p_idFactura" :p_estadoFactura="datoFactura.estadoFactura" />
    </div>

<!-- Modal Anulación -->
<div class="modal fade" id="modalAnulacion" ref="modalAnulacion" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header bg-danger text-white">
        <h5 class="modal-title">
          <span class="material-symbols-outlined me-1" style="font-size:18px">disabled_by_default</span>
          Anular Factura
        </h5>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <p>
          ¿Está seguro que desea anular la factura
          <strong># {{ datoFactura.numero }}</strong>?
        </p>
        <div class="mb-3">
          <label class="form-label fw-bold">
            Motivo de anulación <span class="text-danger">*</span>
          </label>
          <textarea
            class="form-control"
            :class="{ 'is-invalid': errorMotivo }"
            v-model="motivoAnulacion"
            rows="3"
            placeholder="Ingrese el motivo..."
            @input="motivoAnulacion = motivoAnulacion.toUpperCase()"
          ></textarea>
          <div class="invalid-feedback">El motivo de anulación es obligatorio.</div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          class="btn btn-secondary btn-sm"
          data-bs-dismiss="modal"
          @click="errorMotivo = false; motivoAnulacion = ''"
        >
          Cancelar
        </button>
        <button
          class="btn btn-danger btn-sm d-flex align-items-center gap-1"
          @click.prevent="anularFactura"
          :disabled="cargando"
        >
          <span class="material-symbols-outlined" style="font-size:16px">disabled_by_default</span>
          {{ cargando ? 'Anulando...' : 'Confirmar Anulación' }}
        </button>
      </div>
    </div>
  </div>
</div>

    <Footer />
  </div>
</template>

<script>
import Layout           from '@/components/Layout.vue'
import Footer           from '@/components/Footer.vue'
import AyudaFacturacion from '@/views/ayuda/AyudaFacturacion.vue'
import FacturaXML       from '@/components/FacturaXML.vue'
import FacturaDet       from '../forms/FacturaDet.vue'
import Pago             from '../forms/Pago.vue'
import { Modal }        from 'bootstrap';
import dateFormat       from '@/modules/dateFormat.js';
import { validarForm }  from '@/modules/validacionesForms.js'
import api              from '@/services/api'
import swal             from 'sweetalert2'

export default {
  name: 'FacturaForm',
  components: { Layout, Footer, FacturaDet, Pago, FacturaXML, AyudaFacturacion },

/*
  props: {
    p_idAtencion: { type: String, required: true },
    p_numero    : { type: String, required: true },
  },
*/

  data() {
    return {
      datoFactura:            {},
      datoAtencion:           null,	  
      p_idFactura:            0,
      personas:               [],
      mostrarBloque:          false,
      showTable:              'facturaDet',
      showModalHelp:          false,
      notificaciones:         [],
      personaSearch:          '',
      personasFiltradas:      [],
      mostrarDropdownPersona: false,
      personaSeleccionada:    '',
buscandoPersona:  false,
debounceTimer:    null,
motivoAnulacion: '',
errorMotivo:     false,
cargando:        false,
    }
  },

async mounted() {
  this.p_idFactura  = history.state.idFactura
  this.p_idAtencion = history.state.idAtencion
  this.p_numero     = history.state.numero

  this.$refs.layoutRef.toggleProcesos()
  this.$refs.layoutRef.toggleReportes()
  this.$refs.layoutRef.toggleParametros()
  this.$refs.layoutRef.toggleAyuda()

  await this.fetchPersonas()
  this.getData(this.p_idFactura)

  if (!this.p_idAtencion) {
    await this.getAtencionPorFactura(this.p_idFactura)
  }
},

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
  
badgeEstadoFactura(estado) {
  const clases = {
    'PENDIENTE': 'badge-pendiente',
    'EMITIDA':   'badge-emitida',
    'ANULADA':   'badge-anulada',
  };
  return clases[estado] ?? 'badge-pendiente';
},
  
    // ── Carga ──────────────────────────────────────────────────
    async fetchPersonas() {
      try {
        const { data } = await api.get('/vwpersonas')
        this.personas = data
      } catch (e) {
        console.error('Error fetching personas:', e)
      }
    },

    getData(idFactura) {
      if (!idFactura) return
      api.get('/vwfacturas/' + idFactura).then(resp => {
        this.datoFactura = resp.data
        const persona = this.personas.find(p => p.idPersona === this.datoFactura.idPersona)
        if (persona) {
          this.personaSeleccionada = `${persona.documento} — ${persona.nombreCompleto}`
          this.personaSearch       = this.personaSeleccionada
        }
      })
    },

async getAtencionPorFactura(idFactura) {
  try {
    const { data } = await api.get(`/vwatencions/idfactura/${idFactura}`)
    this.datoAtencion = data.length > 0 ? data[0] : null

    if (this.datoAtencion) {
      this.p_idAtencion = this.datoAtencion.idAtencion
    } else {
      console.warn('No se encontró atención para la factura:', idFactura)
    }
  } catch (error) {
    console.error('Error obteniendo atención:', error)
  }
},

    // ── Búsqueda persona ───────────────────────────────────────
onPersonaInput() {
  clearTimeout(this.debounceTimer)
  this.personaSeleccionada = ''
  if (this.personaSearch.length < 2) {
    this.personasFiltradas = []
    return
  }
  this.buscandoPersona = true
  this.debounceTimer = setTimeout(() => {
    this.filtrarPersonas()
  }, 300)
},

filtrarPersonas() {
  const q = this.personaSearch.toLowerCase().trim()
  this.personasFiltradas = this.personas.filter(p =>
    p.nombreCompleto?.toLowerCase().includes(q) ||
    p.documento?.toLowerCase().includes(q)
  ).slice(0, 15)
  this.buscandoPersona = false
},

limpiarPersona() {
  this.personaSearch          = ''
  this.personaSeleccionada    = ''
  this.personasFiltradas      = []
  this.datoFactura.idPersona  = null
},

seleccionarPersona(persona) {
  this.datoFactura.idPersona  = persona.idPersona
  this.personaSeleccionada    = `${persona.documento} — ${persona.nombreCompleto}`
  this.personaSearch          = ''
  this.mostrarDropdownPersona = false
  this.personasFiltradas      = []
},

ocultarDropdownPersona() {
  setTimeout(() => { this.mostrarDropdownPersona = false }, 150)
},

    // ── Guardar ────────────────────────────────────────────────
    validarForm() {
      return validarForm(
        this.datoFactura,
        ['idPersona', 'fechaEmision', 'descripcion', 'estadoFactura'],
        ['Persona', 'Fecha Emisión', 'Descripción', 'Estado']
      )
    },

async guardarFactura(estadoFactura) {
  if (this.validarForm() !== 1) return
  if (estadoFactura !== 'PENDIENTE') this.datoFactura.estadoFactura = estadoFactura
  try {
    await api.post('/facturas', this.datoFactura)
    await swal.fire({
      icon:              'success',
      title:             '¡Correcto!',
      text:              'Factura guardada exitosamente.',
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#198754',
    })
    this.getData(this.p_idFactura)
  } catch (error) {
    swal.fire({
      icon:              'error',
      title:             '¡Error!',
      text:              'Inténtelo de nuevo.',
      confirmButtonText: 'Cerrar',
      confirmButtonColor: '#dc3545',
    })
  }
},
	
    formatMoneda(valor) {
      return valor != null ? Number(valor).toFixed(2) : '0.00'
    },
	
async anularFactura() {
  this.errorMotivo = !this.motivoAnulacion.trim()
  if (this.errorMotivo) return

  // Si no tenemos idAtencion, buscarlo antes de continuar
  if (!this.p_idAtencion) {
    await this.getAtencionPorFactura(this.p_idFactura)
  }

  // Si después de buscar sigue sin encontrarse, advertir
  if (!this.p_idAtencion) {
    swal.fire({
      icon: 'warning',
      title: 'Aviso',
      text: 'No se encontró la atención asociada a esta factura.',
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#ffc107',
    })
    return
  }

  console.log('idFactura:  ', this.p_idFactura)
  console.log('idAtencion: ', this.p_idAtencion)
  console.log('motivo:     ', this.motivoAnulacion)

  this.cargando = true
  try {
    const response = await api.put('/facturas/anular', {
      idFactura:       this.p_idFactura,
      idAtencion:      this.p_idAtencion,
      motivoAnulacion: this.motivoAnulacion
    })
    const modal = Modal.getInstance(this.$refs.modalAnulacion)
    modal.hide()
    if (response.data.exito) {
      await swal.fire({
        icon:              'success',
        title:             '¡Anulada!',
        text:              response.data.mensaje,
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#198754',
      })
      this.$router.push('/atencionfacturacion')
    } else {
      swal.fire({
        icon:              'warning',
        title:            'Aviso',
        text:              response.data.mensaje,
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#ffc107',
      })
    }
  } catch (error) {
    swal.fire({
      icon:              'error',
      title:             'Error',
      text:              'Error al anular la factura: ' + error.message,
      confirmButtonText: 'Cerrar',
      confirmButtonColor: '#dc3545',
    })
  } finally {
    this.cargando = false
  }
},
  },
}
</script>

<style src="@/assets/css/tabs.css" scoped></style>
<style scoped>
.fact-card {
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}
.fact-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  background: #f7f8fa;
  border-bottom: 1px solid #e8e8e8;
}
.fact-numero {
  font-size: 0.9rem;
  font-weight: 600;
  color: #444;
}
.fact-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
}
.badge-emitida   { background: #d1fae5; color: #065f46; }
.badge-pendiente { background: #fef3c7; color: #92400e; }
.badge-anulada   { background: #fee2e2; color: #991b1b; }

.fact-body  { padding: 16px; }
.fact-extra {
  background: #fafafa;
  border: 1px dashed #e0e0e0;
  border-radius: 8px;
  padding: 12px 16px;
}
.fact-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 12px;
}
.fact-field {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 140px;
}
.fact-field--sm   { flex: 0 1 180px; }
.fact-field--full { flex: 1 1 100%; }

.fact-lbl {
  font-size: 0.72rem;
  font-weight: 600;
  color: #9aa0ac;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 3px;
}
.fact-val {
  font-size: 0.875rem;
  color: #3a3a3a;
  padding: 5px 8px;
  background: #f7f8fa;
  border-radius: 6px;
  border: 1px solid #ebebeb;
}
.fact-val.muted { color: #888; font-size: 0.82rem; }

.btn-toggle {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 4px 12px;
  font-size: 0.8rem;
  color: #666;
  cursor: pointer;
  transition: all 0.15s;
}
.btn-toggle:hover { background: #f0f0f0; }

@media (max-width: 576px) {
  .fact-header { flex-direction: column; gap: 10px; align-items: flex-start; }
  .fact-field--sm { flex: 1 1 100%; }
}

.tab-bar {
  display: flex;
  align-items: stretch;
  gap: 4px;
  border-bottom: 2px solid #dee2e6;
  background: #f8f9fa;
  border-radius: 8px 8px 0 0;
  padding: 6px 8px 0;
  flex-wrap: wrap;
}
.tablink {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 7px 12px 8px;
  border: 1px solid transparent;
  border-bottom: none;
  background: none;
  cursor: pointer;
  font-size: 14px;
  color: #6c757d;
  border-radius: 6px 6px 0 0;
  white-space: nowrap;
  transition: background .15s, color .15s;
}
.tablink:hover  { background: #e9ecef; color: #343a40; }
.active-tab {
  background: #fff;
  color: #0d6efd;
  border-color: #dee2e6;
  font-weight: 500;
  margin-bottom: -2px;
  border-bottom: 2px solid #fff;
}

.persona-row {
  display: flex;
  align-items: center;
  gap: 6px;
}
.persona-icon-side {
  font-size: 20px;
  color: #9aa0ac;
  flex-shrink: 0;
}
.persona-input-wrap {
  position: relative;
  flex: 1;
}
.persona-side-spinner {
  flex-shrink: 0;
}
.persona-clear-btn {
  flex-shrink: 0;
  background: none;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  color: #9aa0ac;
  cursor: pointer;
  padding: 3px 6px;
  display: flex;
  align-items: center;
  transition: all 0.15s;
}
.persona-clear-btn:hover {
  background: #fee2e2;
  border-color: #f76c6c;
  color: #dc3545;
}
.persona-dropdown {
  position: absolute;
  z-index: 1000;
  width: 100%;
  top: 100%;
  background: #fff;
  border: 1px solid #dee2e6;
  border-top: none;
  border-radius: 0 0 8px 8px;
  max-height: 240px;
  overflow-y: auto;
  list-style: none;
  padding: 0;
  margin: 0;
}
.persona-option {
  display: flex;
  align-items: baseline;
  gap: 8px;
  padding: 7px 12px;
  cursor: pointer;
  border-bottom: 1px solid #f2f2f2;
  transition: background 0.1s;
}
.persona-option:last-child { border-bottom: none; }
.persona-option:hover      { background: #f0f4ff; }
.persona-doc {
  font-weight: 600;
  font-size: 0.78rem;
  color: #0d6efd;
  white-space: nowrap;
}
.persona-nombre {
  font-size: 0.85rem;
  color: #343a40;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.persona-empty {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 12px;
  font-size: 0.83rem;
  color: #6c757d;
}

.fact-seccion-titulo {
  font-size: 0.75rem;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0 0 8px;
  display: flex;
  align-items: center;
  gap: 5px;
}
.fact-divider {
  border: none;
  border-top: 1px solid #ebebeb;
  margin: 12px 0;
}
</style>